
import Vue from "vue";
import { AuthService, UserConfigService } from "@/services";
import { EditTabSettings } from "@/models/user-configs/edit-tab-settings";
import { DefaultEditTab, getDefaultEditTabs } from "@/utils/tabs/default-edit-tabs";

export default Vue.extend({
	data() {
		return {
			settings: UserConfigService.getEditTabSettings(),
			saveVersion: 0,
			saving: false
		};
	},
	props: {
		browseName: {
			type: String,
			required: true
		},
		browseId: {
			type: Number,
			required: true
		}
	},
	computed: {
		tabs(): DefaultEditTab[] {
			return getDefaultEditTabs(this.browseId);
		},
		isOwner(): boolean {
			return AuthService.wfCompany != null && AuthService.wfUser.ID == AuthService.wfCompany.OwnerID;
		}
	},
	methods: {
		isHidden(tabKey: string): boolean {
			return this.settings.isHidden(this.browseId, tabKey);
		},
		async setVisible(tabKey: string, visible: boolean) {
			let settings = new EditTabSettings(this.settings.getJSON());
			settings.setHidden(this.browseId, tabKey, !visible);
			this.settings = settings;
			let version = ++this.saveVersion;
			let saved = await UserConfigService.setEditTabSettings(settings);
			if (version == this.saveVersion) {
				this.settings = saved;
			}
		},
		async applyToAllUsers() {
			let confirm = await this.$wf.confirm(this.$ct("default-edit-tabs.apply-confirm"),
				this.$t("common.yes"), this.$t("common.no"), this.$t("common.warning"), "warning");
			if (!confirm) return;
			this.saving = true;
			try {
				this.settings = await UserConfigService.applyEditTabSettingsToAllUsers(this.settings);
				this.$wf.notify(this.$ct("default-edit-tabs.applied").toString(), "success", 3000, "check");
			} finally {
				this.saving = false;
			}
		}
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
